import React from 'react';

const TechLines2 = (props) => {
  const { width, height } = props;
  
  return (
    <svg id="Layer_1" width={width} height={height} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 370.58 127.86">
      <path className="fill-pink"
            d="m330.73,127.86c-4.26,0-7.73-3.47-7.73-7.73s3.47-7.73,7.73-7.73,7.73,3.47,7.73,7.73-3.47,7.73-7.73,7.73Zm0-13.46c-3.16,0-5.73,2.57-5.73,5.73s2.57,5.73,5.73,5.73,5.73-2.57,5.73-5.73-2.57-5.73-5.73-5.73Z"/>
      <path className="fill-pink" d="m324,121.13h-65.55l-35.83-35.83H0v-2h223.45l35.83,35.83h64.72v2Z"/>
      <path className="fill-pink"
            d="m332.36,70l-27.6-27.14.48-37.22,35.16-5.64,27.96,24.17,1.84,38.93-37.84,6.9Zm-25.59-27.97l26.26,25.81,35.09-6.4-1.72-36.32-26.6-23-32.58,5.22-.45,34.69Z"/>
      <path className="fill-pink"
            d="m370.57,63.26l-36.48-6.3-17.29-19.67-.06-.17-11.71-31.73,30.27,8.1,20.81,17.87,14.47,31.91h0Zm-35.44-8.15l32.06,5.54-12.73-28.06-20.13-17.28-26.1-6.98,10.31,27.94,16.58,18.86v-.02Z"/>
      <path className="fill-pink"
            d="m333.68,69.07l-1.98-.29,1.96-13.17,21.11-24.49,12.09-7.33,1.03,1.72-11.95,7.23-20.38,23.73-1.88,12.6Z"/>
      <path className="fill-pink"
            d="m306.19,43.35l-.86-1.8,11.69-5.57,16.92-22.08,5.22-13.21,1.86.74-5.41,13.57-17.29,22.58-12.13,5.77Z"/>
    </svg>
  );
}

export default TechLines2;